<template>
  <!-- 2024 补充工伤 -->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="gohome"><a>首页</a></el-breadcrumb-item>
        <el-breadcrumb-item>受理记录</el-breadcrumb-item>
        <el-breadcrumb-item>补充工伤受理记录</el-breadcrumb-item>
      </el-breadcrumb>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 24px;font-weight: 500;">补充工伤受理记录</span>
        </div>
        <div class="demo-input-suffix">
          选择年份：
          <el-date-picker
              v-model="year"
              type="year" format="yyyy"
              value-format="yyyy"
              placeholder="选择年">
          </el-date-picker>
          <el-button type="primary" style="margin-left: 20px;" @click="getsljlList">查询</el-button>
        </div>
        <el-table :data="bcgsxsljlList" v-loading="pictLoading"
                  element-loading-background="rgba(0, 0, 0, 0.5)"
                  element-loading-text="数据正在加载中"
                  element-loading-spinner="el-icon-loading" border stripe value-format="timestamp"
                  :header-cell-style="thStyleFun" :cell-style="cellStyleFun">
          <el-table-column prop="timeaction" label="开始时间" :formatter="dateFormat" width="90"></el-table-column>
          <el-table-column prop="timeend" label="结束时间" :formatter="dateFormat" width="90"></el-table-column>
          <el-table-column prop="num" label="参保人数" width="46"></el-table-column>
          <el-table-column prop="term" label="缴费类型" :formatter="termFormat" width="70"></el-table-column>
          <el-table-column prop="spacec" label="本期应缴金额" width="60"></el-table-column>
          <el-table-column prop="spaceb" label="申报日期" width="90"></el-table-column>
          <el-table-column prop="spaceg" :formatter="spacegFormat" label="办理状态" width="70"></el-table-column>
          <el-table-column prop="spacef" label="人员状态" :formatter="spacefFormat" width="70"></el-table-column>
          <el-table-column prop="userstatus" label="申报状态" :formatter="userstatusFormat" width="70"></el-table-column>
          <el-table-column label="人员名单" prop="userstatus" width="80" fixed="right">
            <template slot-scope="scope">
              <el-link v-if="scope.row.userstatus == '1'" type="primary" @click="getrylbList(scope.row)"
                         round>人员名单</el-link>
              <span v-if="scope.row.userstatus != '1'">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="264" fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" v-if="scope.row.userstatus != '1'" size="mini" @click="cxsb(scope.row)">
                重新申报
              </el-button>
              <el-button type="success" v-if="scope.row.userstatus != '1' && scope.row.spaceg == '0'" v-loading.fullscreen.lock="fullscreenLoading"
                         size="mini" @click="sqhd(scope.row)">申请核定
              </el-button>
              <el-button type="success" v-if="scope.row.userstatus == '1'" size="mini" @click="wbdhdxy(scope.row)">
                无变动核定下月
              </el-button>
              <el-button type="primary" v-if="scope.row.userstatus == '1'" size="mini" @click="dyhdd(scope.row)">
                打印本期核定单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="queryInfo.pageNum" :page-sizes="[50, 100]" :page-size="queryInfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-card>
      <!-- 展示人员列表 -->
      <el-dialog title="人员名单" :visible.sync="dialogRylb">
        <el-table :data="rylbList" v-loading="pictLoading_rylb" element-loading-background="rgba(0, 0, 0, 0.5)"
                  element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading" border height="530"
                  stripe value-format="timestamp" :header-cell-style="thStyleFun"
                  :cell-style="cellStyleFun">
          <el-table-column type="index" width="80" label="编号"></el-table-column>
          <el-table-column prop="aac003" label="姓名" width="120"></el-table-column>
          <el-table-column prop="aac002" label="身份证号"></el-table-column>
          <el-table-column prop="timeaction" label="开始时间" :formatter="dateFormat"></el-table-column>
          <el-table-column prop="timeend" label="结束时间" :formatter="dateFormat"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                       :current-page="queryInfo1.pageNum" :page-sizes="[30, 50, 100, 500]"
                       :page-size="queryInfo1.pageSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="total1"></el-pagination>
      </el-dialog>
      <!-- 展示人员列表 -->
      <el-dialog :visible.sync="dialogdyhdd" @closed="dialog_close">

        <div id="printDiv">
          <table align="center">
            <tbody>
            <tr>
              <td colspan="6" style="text-align:center;" align="center">
                <h3>{{ picctitle }}</h3>
              </td>
            </tr>
            <tr>
              <td width="330" align="left">单位类型：企业</td>
              <td width="330" align="left">填表日期：{{ piccnew.spaceb }}
              </td>
              <td width="330" align="left">金额单位：元
              </td>
            </tr>
            <tr>
              <td colspan=3>
                <table id="table2" bordercolordark="#000000"
                       style="font-size: 10pt;line-height: 30px;text-align: center;" width="100%" cellspacing="0"
                       cellpadding="2" bordercolor="#000000" border="1">
                  <tbody>
                    <tr>
                      <td colspan="2" rowspan="5">缴</br>费</br>单</br>位</td>
                      <td>全称</td>
                      <td colspan="4">{{ user.aab002 }}</td>
                    </tr>
                    <tr>
                      <td>税务登记号</td>
                      <td colspan="4">{{ user.swdjzhm }}</td>
                    </tr>
                    <tr>
                      <td>社保登记证编号</td>
                      <td colspan="2">{{ user.sbdjbh }}</td>
                      <td>单位电脑编号</td>
                      <td>{{ piccnew.aab001 }}</td>
                    </tr>
                    <tr>
                      <td>开户银行</td>
                      <td colspan="4">{{ user.khyh }}</td>
                    </tr>
                    <tr>
                      <td>账号</td>
                      <td colspan="4">{{ user.zh }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">缴费方式</td>
                      <td>补充险征收</td>
                      <td>开始时间</td>
                      <td>{{ piccnew.timeaction }}</td>
                      <td>终止时间</td>
                      <td>{{ piccnew.timeend }}</td>
                    </tr>
                    <tr v-if="piccnew.term == '1'">
                      <td>费款所属期</td>
                      <td>缴费项目</td>
                      <td colspan="2">在职（人数）</td>
                      <td colspan="2">缴费标准</td>
                      <td>缴费合计</td>
                    </tr>
                    <tr v-if="piccnew.term == '1'">
                      <td>{{ timeaction }}-{{timeend}}</td>
                      <td>补充工伤保险</td>
                      <td colspan="2">{{ piccnew.num }}</td>
                      <td colspan="2">{{ piccnew.bxbl }}元/人/月</td>
                      <td>{{ piccnew.spacec }}</td>
                    </tr>
                    <tr v-if="piccnew.term == '1'">
                      <td colspan="2">合计</td>
                      <td colspan="5">{{ piccnew.spacec }}</td>
                    </tr>
                    <tr v-if="piccnew.term == '2'">
                      <td>{{ timeaction }}-{{timeend}}</td>
                      <td>补充工伤补缴保险</td>
                      <td colspan="2">{{ piccnew.num }}</td>
                      <td colspan="2">{{ piccnew.bxbl }}元/人/月</td>
                      <td>{{ piccnew.spacec }}</td>
                    </tr>
                    <tr v-if="piccnew.term == '2'">
                      <td colspan="2">合计</td>
                      <td colspan="5">{{ piccnew.spacec }}</td>
                    </tr>

                    <tr v-if="piccnew.term == '5'">
                      <td>费款所属期</td>
                      <td>缴费项目</td>
                      <td >在职（人数）</td>
                      <td >退休（人数）</td>
                      <td colspan="2">缴费标准</td>
                      <td>缴费合计</td>
                    </tr>
                    <tr v-if="piccnew.term == '5'">
                      <td>{{ pby.timeend }}</td>
                      <td>补充医疗保险</td>
                      <td>{{ pby.zznum }}</td>
                      <td>{{ pby.txnum }}</td>
                      <td colspan="2">{{ pby.jfbz }}</td>
                      <td>{{ pby.jfhj }}</td>
                    </tr>

                    <tr v-if="piccnew.term == '5'">
                      <td colspan="2">合计</td>
                      <td colspan="5">{{ piccnew.spaceg }}</td>
                    </tr>
                    <tr>
                      <td colspan="2" rowspan="6" style="position: relative"> 补充保险核定单专用章：<div id="imgkey" style="position: absolute; left: 45px;top: 4px">
                        <img v-if="piccnew.term == '1'" style="filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true'  )" width="120" height="120" src="http://pjht.lnbcgs.com/images/lnpjbcgsbxzyz.png"/>
                        <img v-if="piccnew.term == '2'" style="filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true'  )" width="120" height="120" src="http://pjht.lnbcgs.com/images/lnpjbcgsbxzyz.png"/>
                        <img v-if="piccnew.term == '5'" style="filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true'  )" width="120" height="120" src="http://pjht.lnbcgs.com/images/lnpjbcylbxzyz.png"/>
                      </div></td>
                      <td colspan="3" rowspan="6">
                        <div style="border-bottom: 2px solid #000;text-align: left">补充保险缴费账户：</div>
                        <div style="border-bottom: 2px solid #000;text-align: left">中国人民健康保险股份有限公司盘锦中心支公司</div>
                        <div style="border-bottom: 2px solid #000;text-align: left">开户行：{{piccnew.khy}}</div>
                        <div style="border-bottom: 2px solid #000;text-align: left">账号：{{piccnew.khyzh}}</div>
                        <div style="border-bottom: 2px solid #000;text-align: left">地址：辽宁省盘锦市兴隆台区市府大街38号</div>
                        <div style="text-align: left">电话：0427-6657809</div>
                      </td>
                      <td colspan="2" rowspan="6">审核经办人： {{piccnew.spaced}}</td>
                    </tr>
                  </tbody>
                </table>
                <div> 注：企业必须在每月15号前缴费。</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="text-align: center;padding-top: 20px;">
          <el-button type="primary" style="width: 220px;" plain v-print="'#printDiv'">打印</el-button>
        </div>

      </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import moment from "moment";
    export default {
        inject: ['reload'],
        data() {

            return {

                queryInfo: {
                    pageNum: 1,
                    pageSize: 50,
                },
                queryInfo1: {
                    pageNum: 1,
                    pageSize: 30,
                },
                year: '',
                total: 0,
                total1: 0,
                bcgsxsljlList: [], // 用户列表
                rylbList: [], // 人员列表
                dialogRylb: false, //显示人员列表对话框
                dialogdyhdd: false, //显示打印核定单
                user: {},
                piccnew: {}, //核定单piccnew
                pby:{},
                pu:{},
                rymdshow: false,
                rymdshow_1: false,

                timeaction: null,
                timeend: null,
                //补缴月数
                monthnum: 0,


                //申请核定等待
                fullscreenLoading: false,

                //受理记录数据加载等待
                pictLoading: true,

                //人员列表数据加载等待
                pictLoading_rylb: true,
              picctitle:'补充工伤申报表',
              term:'1',
                thStyleFun() {
                    return 'text-align:center'
                },
                cellStyleFun() {
                    return 'text-align:center'
                }

            }

        },
        created() {
            this.activePath = window.sessionStorage.getItem('activePath');
            window.addEventListener('setItem', () => {

                this.activePath = window.sessionStorage.getItem("activePath");


            })
            this.user = JSON.parse(window.sessionStorage.getItem("user"));
            let moment = require('moment');
            var year = '' + moment().year();
            this.year = year;
            this.getsljlList();

        },
        methods: {

            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getsljlList(); // 数据发生改变重新申请数据
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getsljlList(); // 数据发生改变重新申请数据
            },
            // 监听pageSize改变的事件
            handleSizeChange1(newSize) {
                this.queryInfo1.pageSize = newSize;
                this.getrylbList(); // 数据发生改变重新申请数据
            },
            // 监听pageNum改变的事件
            handleCurrentChange1(newPage) {
                this.queryInfo1.pageNum = newPage;
                this.getrylbList(); // 数据发生改变重新申请数据
            },
            async getsljlList() {
                this.pictLoading = true;
                var formData = new FormData()
                formData.append('pageNum', this.queryInfo.pageNum);
                formData.append('pageSize', this.queryInfo.pageSize);
                formData.append('aab001', this.user.aab001);
                formData.append('year', this.year);
                //月缴
                formData.append('term', this.term);
                // 调用post请求
                const {

                    data: res
                } = await this.$http.post("getsljlList", formData, {}, {


                });
                this.bcgsxsljlList = res.bcgssljlList; // 将返回数据赋值
                this.total = res.bcgsslCount; // 总个数
                this.pictLoading = false;
            },
            dateFormat: function(row, column) {
                var date = row[column.property];

                if (date == undefined) {
                    return "";
                }
                var moment = require("moment");
                return moment(date).format("YYYY-MM-DD");
            },
            dialog_close(){
              this.dialogdyhdd=false
            },
            termFormat(row, column) {
                var term = row.term;
                if (term == undefined) {
                    return "-";
                }
                if (term == '1') {
                    return "补充工伤";
                }
                if (term == '2') {
                    return "补充工伤补缴";
                }
                if (term == '5') {
                    return "补充医疗年缴";
                }
            },
            spacegFormat(row, column) {
                var spaceg = row.spaceg;
                if (spaceg == undefined) {
                    return "-";
                }
                if (spaceg == '0') {
                    return "正常办理";
                }
                if (spaceg == '1') {
                    return "代办缴费";
                }
                if (spaceg == '2') {
                    return "代办变更";
                }

            },
            spacefFormat(row, column) {
                var spacef = row.spacef;
                if (spacef == undefined) {
                    return "-";
                }
                if (spacef == '0') {
                    return "未上传";
                }
                if (spacef == '1') {
                    return "上传成功";
                }

            },
            userstatusFormat(row, column) {
                var userstatus = row.userstatus;
                if (userstatus == undefined) {
                    return "-";
                }
                if (userstatus == '0') {
                    return "待核定";
                }
                if (userstatus == '1') {
                    return "已投保";
                }
                if (userstatus == '2') {
                    return "无效";
                }

            },
            async cxsb(cxsb) {
                var jffs = "";
                if (cxsb.term == '1') {
                    // this.resetSetItem('activePath', "/yearpay");
                    // this.$router.push({
                    //     name: 'yearpay',
                    //     params: {
                    //         id: cxsb.spacea
                    //     }
                    // })
                    jffs = "撤销年缴申报"
                }
                if (cxsb.term == '2') {
                    // this.resetSetItem('activePath', "/changeRenewal");
                    // this.$router.push({
                    //     name: 'changeRenewal',
                    //     params: {
                    //         id: cxsb.spacea
                    //     }
                    // })
                    jffs = "撤销月缴申报"
                }
                if (cxsb.term == '3') {
                    // this.resetSetItem('activePath', "/jdjf");
                    // this.$router.push({
                    //     name: 'jdjf',
                    //     params: {
                    //         id: cxsb.spacea
                    //     }
                    // })
                    jffs = "撤销季缴申报"
                }
                if (cxsb.term == '4') {
                    // this.resetSetItem('activePath', "/bjgwyf");
                    // this.$router.push({
                    //     name: 'bjgwyf',
                    //     params: {
                    //         id: cxsb.spacea
                    //     }
                    // })
                    jffs = "撤销补缴申报"
                }
                const confirmResult = await this.$confirm(jffs + ', 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)
                    // 成功删除为confirm 取消为 cancel
                if (confirmResult != 'confirm') {
                    return this.$message.info("已取消！！！");
                }
                const {
                    data: res
                } = await this.$http.get("deletpiccnew?spacea=" + cxsb.spacea);
                if (res != "success") {
                    return this.$message.error("撤销申报失败！！！");
                }
                this.$message.success("已撤销申报！！！");
                this.getsljlList();
                // this.reload();
            },
            async sqhd(piccnew_sqhd) {
              console.log(piccnew_sqhd);
              // 弹框
                const confirmResult = await this.$confirm('申请核定后保单将不能进行修改', '请确认', {
                        async: false,
                        cache: false,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)
                    // 成功删除为confirm 取消为 cancel
                if (confirmResult != 'confirm') {
                    return this.$message.info("已取消提交");
                }
                this.fullscreenLoading = true;
                piccnew_sqhd.userstatus   =   '1';
                const {data: res} = await this.$http.post("updateUserstatus", piccnew_sqhd, {
                }).catch((err) => {
                    this.$message.error("申请核定失败！！！")
                  piccnew_sqhd.userstatus   =   '0';
                    this.fullscreenLoading = false;
                });
                if (res != "success") {
                  //20231116 lyx 返回错误信息 提示
                  piccnew_sqhd.userstatus   =   '0';
                  this.fullscreenLoading = false;
                   this.$message.error(res);
                  return
                }
                this.fullscreenLoading = false;
                this.getsljlList();

                this.$message.success("申请核定成功！！！");

            },
            //获取人员列表
            async getrylbList(rylbrow) {
                this.pictLoading_rylb = true;
                if (rylbrow != undefined) {
                    this.timeaction = new Date(rylbrow.timeaction);
                    this.timeend = new Date(rylbrow.timeend);
                }
                this.dialogRylb = true;
                var formData = new FormData()
                formData.append('pageNum', this.queryInfo1.pageNum);
                formData.append('pageSize', this.queryInfo1.pageSize);
                formData.append('aab001', this.user.aab001);
                formData.append('timeaction', this.timeaction);
                formData.append('timeend', this.timeend);
              formData.append('spacea', rylbrow.spacea);
                // 调用post请求
                const {

                    data: res
                } = await this.$http.post("getrylbList", formData, {}, {


                });
                this.rylbList = res.rylbList; // 将返回数据赋值
                console.log(res.rylbList);
                this.total1 = res.rylbListCount; // 总个数
                this.pictLoading_rylb = false;

            },
            //打印本期核定单
            async dyhdd(dyhddRow) {
                this.dialogdyhdd = true;
                this.piccnew = dyhddRow;
                let moment = require("moment");
                // this.piccnew.timeaction = moment(dyhddRow.timeaction).format("YYYY-MM-DD").substring(0,4)+"年"+moment(dyhddRow.timeaction).format("YYYY-MM-DD").substring(5,7)+"月";

                // if(this.piccnew.timeaction.substring(5,6) ==0){
                //     this.piccnew.timeaction = this.piccnew.timeaction.substring(0,4)+"年"+this.piccnew.timeaction.substring(6,7)+"月";
                // }
                this.timeaction =moment(dyhddRow.timeaction).format("YYYY-MM-DD").substring(0,7);
                this.timeend =moment(dyhddRow.timeend).format("YYYY-MM-DD").substring(0,7);
                this.piccnew.timeaction = moment(dyhddRow.timeaction).format("YYYY-MM-DD");
                this.piccnew.timeend = moment(dyhddRow.timeend).format("YYYY-MM-DD");
                if (dyhddRow.term == '4') {
                    let date1 = this.piccnew.timeend.split('-'); //例：将2020-12-21 的-去掉
                    date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]); //将字符串转换为数字格式
                    let date2 = this.piccnew.timeaction.split('-');
                    date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
                    this.monthnum = date1 - date2;
                }
              if (dyhddRow.term == '1') {
                this.picctitle ="补充工伤申报表";
              }
              if (dyhddRow.term == '2') {
                this.picctitle ="补充工伤补缴申报表";
              }
              if (dyhddRow.term == '5') {
                this.picctitle ="补充医疗申报表";
              }
                 // 调用post请求
                var formData = new FormData()
                formData.append('aab001', this.user.aab001);
                formData.append('timeaction', '' + moment().startOf('year').format('YYYY-MM-DD'));
                const {
                    data: res
                } = await this.$http.post("getdyhdd", formData, {}, {

                });
                this.pu = res.pu
              console.log(res)
                if(res.pby.aab001!=null){
                  this.pby = res.pby;
                }
              console.log(this.pby)
                this.piccnew.spaceg = parseInt(this.piccnew.spacec) + (this.pby.jfhj==null?"":parseInt(this.pby.jfhj))+"";

            },
            //返回首页
            gohome() {
                window.sessionStorage.setItem('activePath', "/welcome");
                this.$router.push("/welcome");
                this.reload();
            },
          async wbdhdxy(dyhddRow) {
            const confirmResult = await this.$confirm('确定人员信息同本月核定?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).catch(err => err)
            // 成功删除为confirm 取消为 cancel
            if (confirmResult != 'confirm') {
              return this.$message.info("已取消");
            }
            // let moment = require("moment");
            // this.timeaction =moment(dyhddRow.timeaction).format("YYYY-MM-DD").substring(0,7);
            // this.timeend =moment(dyhddRow.timeend).format("YYYY-MM-DD").substring(0,7);
            // this.piccnew.timeaction = moment(dyhddRow.timeaction).format("YYYY-MM-DD");
            // this.piccnew.timeend = moment(dyhddRow.timeend).format("YYYY-MM-DD");

            // 调用post请求
            var formData = new FormData()
            formData.append('uuid', dyhddRow.spacea);
            const {
              data: res
            } = await this.$http.post("gettsyhd", formData, {}, {

            });
            if(res.status == 200){
              this.$message.success(res.msg);
              this.getsljlList();
            }else{
              this.$message.error(res.msg);
            }
          },

        }
    }
</script>

<style lang="less" scoped>

</style>
